import React from 'react';
import PropTypes from 'prop-types';
import NavItem from 'react-bootstrap/lib/NavItem';
import Nav from 'react-bootstrap/lib/Nav';
import NavDropdown from 'react-bootstrap/lib/NavDropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import Navbar from 'react-bootstrap/lib/Navbar';
import NavLink from './NavLink';
import NAV_ITEM from '../../constantValues/NAV_ITEM_PROPERTIES';

const NavMenu = props => (
    <Navbar.Collapse>
        <Nav className={'navbar-links'}>
            {(props.isSuperAdmin || props.isAdmin) &&
                NAV_ITEM.admin.map((obj, i) => (
                    <NavItem eventKey={obj.key + i / 10} key={i}>
                        <NavLink
                            path={obj.path}
                            name={obj.name}
                            className={obj.className}
                        />
                    </NavItem>
                ))}
            {props.isManager &&
                NAV_ITEM.manager.map((obj, i) => (
                    <NavItem eventKey={obj.key + i / 10} key={i}>
                        <NavLink
                            path={obj.path}
                            name={obj.name}
                            className={obj.className}
                        />
                    </NavItem>
                ))}
            {props.isUser &&
                NAV_ITEM.user.map((obj, i) => (
                    <NavItem eventKey={obj.key + i / 10} key={i}>
                        <NavLink
                            path={obj.path}
                            name={obj.name}
                            className={obj.className}
                        />
                    </NavItem>
                ))}
        </Nav>
        <Nav pullRight className={'navbar-links'}>
            <NavDropdown
                className={'navbar-dropdown '}
                title={
                    <img
                        src={props.avatar}
                        className={'navbar-profile-image'}
                        alt={'profile'}
                    />
                }
                id="img"
            >
                <MenuItem eventKey={NAV_ITEM.profile.key}>
                    <NavLink
                        path={NAV_ITEM.profile.path}
                        name={NAV_ITEM.profile.name}
                        className={NAV_ITEM.profile.className}
                    />
                </MenuItem>
                {(props.isManager || props.isAdmin || props.isSuperAdmin) &&
                    NAV_ITEM.dropdown.map((obj, i) => (
                        <MenuItem eventKey={obj.key + i / 10} key={i}>
                            <NavLink
                                path={obj.path}
                                name={obj.name}
                                className={obj.className}
                            />
                        </MenuItem>
                    ))}
                {(props.isAdmin || props.isSuperAdmin) && (
                    <MenuItem eventKey={NAV_ITEM.adminPanel.key}>
                        <NavLink
                            path={NAV_ITEM.adminPanel.path}
                            name={NAV_ITEM.adminPanel.name}
                            className={NAV_ITEM.adminPanel.className}
                        />
                    </MenuItem>
                )}
            </NavDropdown>
        </Nav>
    </Navbar.Collapse>
);

export default NavMenu;

NavMenu.propTypes = {
    avatar: PropTypes.string,
    isSuperAdmin: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isManager: PropTypes.bool,
    isUser: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Navbar/NavMenu.js